import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

import { Box } from '@mui/material';
import { clsx } from 'clsx';

import { SandboxHeader } from 'components/SandboxHeader/SandboxHeader';
import { usePromo } from 'shared/lib/promo/usePromo';
import { useQueryParams } from 'shared/lib/queryParams/useQueryParams';

import { NavBar } from './NavBar';

const LayoutContext = createContext<HTMLDivElement | null>(null);

export const TwoPaneLayout: FC<PropsWithChildren> = ({ children }) => {
  const { promoHeader, promoHeaderHeight } = usePromo();
  // using state instead of ref because we need to update it after children are rendered
  const [layoutEl, setLayoutEl] = useState<HTMLDivElement | null>(null);
  const { action } = useQueryParams();
  const isCreateOrder = action === 'create';

  return (
    <LayoutContext.Provider value={layoutEl}>
      <div
        className={clsx('fixed top-0 w-full', {
          'z-[1301]': isCreateOrder, // MUI backdrop has 1300, and we need the header to be above
          'z-50': !isCreateOrder,
        })}
      >
        {promoHeader}
        <SandboxHeader />
      </div>
      <Box
        className="flex h-full bg-white"
        sx={{
          paddingTop: `${promoHeaderHeight}px`,
        }}
      >
        <div className="flex h-full max-h-screen">
          <NavBar />
        </div>
        <div ref={setLayoutEl} className="relative flex min-w-page max-w-page flex-auto flex-col overflow-auto">
          {children}
        </div>
      </Box>
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  return useContext(LayoutContext);
};
